import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { ApiMasterService } from './api-call-providers/api-master.service';

@Injectable()
export class MasterService {

  // - 契約プランじょうほう　
  private contractSource = new Subject<any>();
  contractInfo = this.contractSource.asObservable();

  plans = {};

  constructor(
    private apiMasterService: ApiMasterService,
  ) {
  }

  /**
   * 契約プランなどの情報を取得する
   * @param params 
   */
  async fetch() {
    let res = await this.apiMasterService.getContractPayments()
    if (res) {
      this.plans = {
        plan: res.plan,
        paymentPlan: res.paymentPlan,
        paymentMethod: res.paymentMethod,
      };
    }
    this.contractSource.next(this.plans)
  }

}


// WEBPACK FOOTER //
// ./src/providers/master.service.ts